<template>
  <div>
    <b-card>
      <div slot="header">
        <span>Vehicle Type</span>
        <a
          href="#"
          class="btn btn-sm btn-info float-right ml-1"
          id="printpagebutton"
          @click="onPrint"
        >
          <i class="fa fa-print"></i> Print
        </a>
        <button
          id="printexport"
          class="btn btn-sm btn-info float-right"
          @click="onexport"
        >
          Export
        </button>
      </div>
      <tr>
        <td>
          <b-button
            variant="primary"
            @click="$router.push('/Maintenance/637454377594731857/new/vehicletype')"
          >
            <i class="fa fa-plus-circle"></i>&nbsp;New Vehicle Type
          </b-button>
        </td>
        <td>
          <b-input-group style="margin-left: 10px; margin-bottom: 10px">
            <b-form-input v-model="filter" placeholder="Search.." />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </td>
      </tr>
      <b-table
        show-empty
        bordered
        responsive="sm"
        class="mb-0 table-outline"
        hover
        small
        autocomplete="off"
        striped
        fixed
        head-variant="light"
        :busy.sync="isBusy"
        :items="items"
        :fields="fields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <!-- <template v-slot:cell(Action)="data">
          <center>
            <router-link
              tag="button"
              :to="
                '/Maintenance/637454377594731857/modify/vehicletype/' +
                data.item.drpdata
              "
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-pencil-square-o"></i> </router-link
            >&nbsp; -->
            <!-- <b-button
              size="sm"
              variant="danger"
              class="btn btn-danger btn-sm"
              @click="onSelecteItemToDelete(data.item)"
            >
              <i class="fa fa-trash-o"></i>
            </b-button> -->
          <!-- </center>
        </template> -->
      
      </b-table>
    </b-card>
    <div style="margin-top: 5px">
      <b-pagination
        size="sm"
        :total-rows="totalItem"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </div>
     <div class="dispatch-list">
          <div>
            <p>Vehicle Type</p>
          </div>
          <div class="newButton">
            <b-button
              variant="primary"
              class="btnsm"
              @click="
                $router.push('/Maintenance/637454377594731857/new/vehicletype')
              "
            >
              <i class="fa fa-plus-circle"></i>&nbsp;New Fleet Type
            </b-button>
          </div>
          <b-list-group
            v-for="(item, index) in items"
            :key="`dynlist-${index}`"
            class="shadow"
          >
            <b-list-group-item class="flex-column align-items-start">
              <div class="list-field">
                <span class="mb-1 dis"
                  >Fleet Type:&nbsp;{{ item.drpdata }}</span
                >
              </div>

              <div class="list-field">
                <span>Description:&nbsp;{{ item.drpdisplay }}</span>
              </div>
          
              <!-- <div class="row">
                <div class="col">
                  <router-link
                    tag="button"
                    :to="
                      '/Maintenance/637454377594731857/modify/vehicles/' +
                      item.drpdata
                    "
                    class="btn btn-primary btnsm btn-block"
                  >
                    <i class="fa fa-pencil-square-o"></i>
                    Edit
                  </router-link>
                   <b-button
                    class="btn btn-danger btnsm btn-block"
                    @click="onSelecteItemToDelete(item)"
                    :disabled='isDisableDelete()'
                  >
                    <i class="fa fa-trash-o"></i>
                    Remove
                  </b-button>
                </div>
              </div> -->
            </b-list-group-item>
          </b-list-group>
        </div>

    <b-modal
        title="System Message"
        v-model="deleteModal"
        @ok="onDeleteItem"
        >
        Are you sure you want to remove
        <strong>{{ selectedItemLabel }} ?</strong>
    </b-modal>

  </div>
</template>

<script>
import api from "../../services/api";
import JSONToCSVConvertor from "./../../services/JSONToCSVConvertor.js";
import miniToastr from "mini-toastr";
import axios from "axios";

export default {
  data() {
    return {
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",

      perPage: this.$store.getters.perPage,
      totalItem: 0,
      currentPage: 1,
      filter: null,
      sortOptions: [],
      isBusy: false,

      vehicletypelist: [],
      fields: [
        // {
        //   key: "Action",
        // },
        {
          key: "drpdata",
          label: "Fleet Type",
          sortable: true,
        },
        {
          key: "drpdisplay",
          label: "Description",
          sortable: true,
        },
      ],
      items:[]
    };
  },

   computed: {
    filter() {
      this.currentPage = 1;
      this.totalrows = this.items.length;
    },

    rows() {
      return this.items.length;
    },

    userId: {
      get: function() {
        return this.$store.getters.userId;
      },
      set: function(value) {}
    },
  },

  created() {
    this.initTable();
    // this.validateAccessDelete();
  },

  methods: {
    onexport: function () {
      JSONToCSVConvertor(this.items, "Vehicle Type List", true);
    },
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onPageSelect: function (page) {
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "get-fleet-list?param=&tk=" + self.perPage + "&pg=" + page
      );
    },

    initTable: function () {
      this.isBusy = true;
      let self = this;
      this.$store.commit("setLoading", true);
      // this.vehicletypelist = [];
      api.instance
        .get(this.$store.state.IFMSURLlocal + 
        "get-select-vehicletype?drpids=VEHICLE")
        .then((resp) => {
          self.items = resp.data;
          self.totalItem = resp.data.length;
          // this.Vehiclelistmodal = true;
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch(function (err) {
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          api.httpMsg(this, err.status, err.data);

          return [];
          
        });
    },
      onSelecteItemToDelete: function (param) {
      this.selectedItem = param;
      this.selectedItemLabel = this.selectedItem.drpdata;
      this.deleteModal = true;
    },
    // validateAccessDelete() {
    //   axios
    //     .get(
    //       api.baseURL +
    //         "account/get-access-filter-delete?menucode=637454377594731857&userId=" +
    //         this.userId
    //     )
    //     .then(response => {
    //       this.canAccessDelete = response.data;
    //     });
    // },
    //    isDisableDelete() {
    //   if (this.canAccessDelete == false) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    //   onDeleteItem: function () {
    //   this.$store.commit("setLoading", true);
    //   axios
    //     .delete(this.$store.state.IFMSURLlocal + 
    //     "remove-fleet-type?drpdata=" + 
    //     this.selectedItem.drpdata)
    //     .then((resp) => {
    //       this.initTable();
    //       miniToastr.success(resp.data);
    //       this.deleteModal = false;
    //       this.$store.commit("setLoading", false);
    //     })
    //     .catch((err) => {
    //       miniToastr.error(error.response.data);
    //       this.$store.commit("setLoading", false);
    //       api.httpMsg(this, err.status, err.data);
    //     });
    // },
  },
};
</script>